import React from 'react';
import { Shield, Lock, CreditCard, CheckCircle } from 'lucide-react';
export function TrustBadges() {
  return <div className="flex flex-col items-center gap-4 py-4" data-id="element-108">
      <div className="flex flex-wrap justify-center items-center gap-3 md:gap-6 opacity-70 grayscale hover:grayscale-0 transition-all duration-300" data-id="element-109">
        {/* Simulated payment icons using text/shapes since we don't have external SVGs */}
        <div className="flex items-center gap-1 font-bold text-blue-800 border border-gray-200 px-2 py-1 rounded bg-white" data-id="element-110">
          <span className="italic" data-id="element-111">Visa</span>
        </div>
        <div className="flex items-center gap-1 font-bold text-red-600 border border-gray-200 px-2 py-1 rounded bg-white" data-id="element-112">
          <div className="flex -space-x-2" data-id="element-113">
            <div className="w-4 h-4 rounded-full bg-red-500 opacity-80" data-id="element-114"></div>
            <div className="w-4 h-4 rounded-full bg-orange-500 opacity-80" data-id="element-115"></div>
          </div>
          <span data-id="element-116">Mastercard</span>
        </div>
        <div className="flex items-center gap-1 font-bold text-blue-500 border border-gray-200 px-2 py-1 rounded bg-white" data-id="element-117">
          <span className="italic" data-id="element-118">PayPal</span>
        </div>
        <div className="flex items-center gap-1 font-bold text-slate-700 border border-gray-200 px-2 py-1 rounded bg-white" data-id="element-119">
          <span data-id="element-120">Apple Pay</span>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500 font-medium" data-id="element-121">
        <div className="flex items-center gap-1.5" data-id="element-122">
          <Lock className="w-3 h-3 text-emerald-600" data-id="element-123" />
          <span data-id="element-124">Pago 256-bit SSL Seguro</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-125">
          <Shield className="w-3 h-3 text-emerald-600" data-id="element-126" />
          <span data-id="element-127">Garantía de Privacidad</span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-128">
          <CheckCircle className="w-3 h-3 text-emerald-600" data-id="element-129" />
          <span data-id="element-130">Compra Verificada</span>
        </div>
      </div>
    </div>;
}